<template>
  <bk-view class="rewardEarned-container">
    <bk-lang class="view-title" code="userInfo_shareInvitefriend_rewardEarned"></bk-lang>
    <bk-view class="view-rewardEarned-list">
      <bk-scroll-list 
        :beforeSearch="beforeSearch" 
        :async-load-data="requestPostShopList" 
        :fixedHeight="false"
      >
        <template v-slot="{ dataList }">
          <bk-view class="view-rewardEarned-item" v-for="(item,index) in dataList" :key="index">
            <bk-view class="view-top-main">
              <bk-title showLeftSign>{{ item.refereeFirstName }}{{ item.refereeLastName }}</bk-title>
              <bk-view class="view-date-main">
                <bk-lang code="userInfo_shareInvitefriend_date"></bk-lang>
                <bk-date :curShop="item" :date="item.createDate.showValue"></bk-date>
              </bk-view>
            </bk-view>
            <bk-view class="view-obtain-main">
              <bk-view class="view-icon"></bk-view>
              <bk-view class="view-rewardGoodsText">{{ item.rewardGoodsText }}</bk-view>
            </bk-view>
            <bk-view class="view-info-main">
              <bk-view class="view-info-item">
                <bk-lang code="userInfo_shareInvitefriend_phoneNumber"></bk-lang>
                <bk-view>{{ item.refereeMobile }}</bk-view>
              </bk-view>
              <bk-view class="view-info-item">
                <bk-lang code="userInfo_shareInvitefriend_email"></bk-lang>
                <bk-view>{{ item.refereeEmail }}</bk-view>
              </bk-view>
              <bk-view class="view-info-item">
                <bk-lang code="userInfo_shareInvitefriend_store"></bk-lang>
                <bk-view>{{ item.compName }}</bk-view>
              </bk-view>
            </bk-view>
          </bk-view>
        </template>
      </bk-scroll-list>
    </bk-view>
  </bk-view>
</template>

<script>
	import { customerReq } from '@/reqService';

	export default {
		name:'rewardEarned',
		data (){
			return { 
        curShop:this.$bk_getShopDetailInfo(),
				userInfo:this.$bk_getUserInfo(),
			};
		},
		methods:{
			beforeSearch (params){
				params.userId = this.userInfo?.id;

        if(this.curShop?.custId){
          if(window.komoDZFlag || window.oblissDZFlag){
            params.custId = this.curShop?.custId;
          }
        }
       
				return params;
			},
			async requestPostShopList (params){
				const res = await customerReq.requestGetShareHistoryList(this, params);
				let total = res?.page?.total;

				this.$emit('action', { total } );

				return { data: res?.list || [], total };
			},
		}
	};
</script>

<style lang="less">
@import './rewardEarned.less';
</style>